<template>
    <div class="buy-page">
        <!-- <span>购买页面</span> -->
        <div v-if="productId === '1001'">
            <div class="top">
                <div class="left">
                    <img src="../assets/images/AKF1.jpg" alt="">
                </div>
                <div class="right">
                    <span>ΛKF 定妆喷雾</span>
                    <ul>
                        <li>定制泵头，细腻如烟，不易留痕</li>
                        <li>有效认证，“雾”必出彩</li>
                        <li>安心成分，分肤定制</li>
                        <li>多重“膜”法，轻盈锁妆</li>
                    </ul>
                    <div class="buyBox">
                        <div class="guige">规格100ml</div>
                        <!-- <div class="buy" @click="goToBuyPage">点击购买</div> -->
                        <div class="buy">点击购买</div>
                    </div>
                </div>
            </div>
            <!-- <div class="bottom">
                <img src="../assets/images/lang.jpg" alt="">
            </div> -->
        </div>
        <div v-else-if="productId === '1002'">
            <div class="top">
                <div class="left">
                    <img src="../assets/images/AKF1.jpg" alt="">
                </div>
                <div class="right">
                    <span>ΛKF 定妆喷雾</span>
                    <ul>
                        <li>定制泵头，细腻如烟，不易留痕</li>
                        <li>有效认证，“雾”必出彩</li>
                        <li>安心成分，分肤定制</li>
                        <li>多重“膜”法，轻盈锁妆</li>
                    </ul>
                    <div class="buyBox">
                        <div class="guige">规格100ml</div>
                        <!-- <div class="buy" @click="goToBuyPage">点击购买</div> -->
                        <div class="buy">点击购买</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="productId === '1004'">
            <div class="none" style="margin-top: 3rem;">
                <h2>上新中</h2>
            <p>敬请期待...</p>
            </div>
        </div>
        <div v-else-if="productId === '1005'">
            <div class="none" style="margin-top: 3rem;">
                <h2>上新中</h2>
            <p>敬请期待...</p>
            </div>
        </div>
        <div v-else-if="productId === '2001'">
            <div class="top">
                <div class="left">
                    <img src="../assets/images/buyNew621/chunni.jpg" alt="">
                </div>
                <div class="right">
                    <span>ΛKF唇泥</span>
                    <ul>
                        <li>慕斯蛋糕质地</li>
                        <li>带你体验丝绒触感</li>
                    </ul>
                    <div class="buyBox">
                        <div class="guige">￥49/3g</div>
                        <!-- <div class="buy" @click="goToBuyPage">点击购买</div> -->
                        <div class="buy">点击购买</div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div style="display: flex;align-items: center;justify-content: center;padding: 0 10%;">
                    <div style="max-width: 100%;height: 2px;background-color: black;flex: 93%;margin-right: 1%;"></div>
                    <div style="flex: 1;">More</div>
                </div>
                <div class="detailsBox">
                    <img class="detailsImg" src="../assets/images/details/chunni.png" alt="">
                </div>
            </div>
        </div>
        <div v-else-if="productId === '2002'">
            <div class="none" style="margin-top: 3rem;">
                <h2>上新中</h2>
            <p>敬请期待...</p>
            </div>
        </div>
        <div v-else-if="productId === '2003'">
            <div class="none" style="margin-top: 3rem;">
                <h2>上新中</h2>
            <p>敬请期待...</p>
            </div>
        </div>
        <div v-else-if="productId === '2004'">
            <div class="top">
                <div class="left">
                    <img src="../assets/images/product/yyp.jpg" alt="">
                </div>
                <div class="right">
                    <span>ΛKF七色综合眼影盘</span>
                    <ul>
                        <li>氛围复古综合盘,实力“眼”绎眸上睛彩</li>
                        <li>粉质细密柔滑，质感色泽好延展</li>
                        <li>多重质地搭配，塑造多元立体双眸</li>
                    </ul>
                    <div class="buyBox">
                        <div class="guige">￥69.9/9g</div>
                        <!-- <div class="buy" @click="goToBuyPage">点击购买</div> -->
                        <div class="buy">点击购买</div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div style="display: flex;align-items: center;justify-content: center;padding: 0 10%;">
                    <div style="max-width: 100%;height: 2px;background-color: black;flex: 93%;margin-right: 1%;"></div>
                    <div style="flex: 1;">More</div>
                </div>
                <div class="detailsBox">
                    <img class="detailsImg" src="../assets/images/details/yanying.png" alt="">
                </div>
            </div>
        </div>
        <div v-else-if="productId === '2005'">
            <div class="none" style="margin-top: 3rem;">
                <h2>上新中</h2>
            <p>敬请期待...</p>
            </div>
        </div>
        <div v-else-if="productId === '2006'">
            <div class="top">
                <div class="left">
                    <img src="../assets/images/buyNew621/sanfen.jpg" alt="">
                </div>
                <div class="right">
                    <span>ΛKF轻透控油散粉</span>
                    <ul>
                        <li>轻薄如云纱 定格柔焦美肌</li>
                        <li>清透控油</li>
                    </ul>
                    <div class="buyBox">
                        <div class="guige">￥59/10g</div>
                        <!-- <div class="buy" @click="goToBuyPage">点击购买</div> -->
                        <div class="buy">点击购买</div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div style="display: flex;align-items: center;justify-content: center;padding: 0 10%;">
                    <div style="max-width: 100%;height: 2px;background-color: black;flex: 93%;margin-right: 1%;"></div>
                    <div style="flex: 1;">More</div>
                </div>
                <div class="detailsBox">
                    <img class="detailsImg" src="../assets/images/details/sanfen.png" alt="">
                </div>
            </div>

        </div>
        <div v-else-if="productId === '2007'">
            <div class="top">
                <div class="left">
                    <img src="../assets/images/buyNew621/JMG.jpg" alt="">
                </div>
                <div class="right">
                    <span>ΛKF轻羽纤长持妆睫毛膏</span>
                    <ul>
                        <li>持久卷翘 细节出众</li>
                        <li>灵动纤长 睫然不同</li>
                        <li>安心配方 一抹净卸</li>
                    </ul>
                    <div class="buyBox">
                        <div class="guige">￥49/5g</div>
                        <!-- <div class="buy" @click="goToBuyPage">点击购买</div> -->
                        <div class="buy">点击购买</div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div style="display: flex;align-items: center;justify-content: center;padding: 0 10%;">
                    <div style="max-width: 100%;height: 2px;background-color: black;flex: 93%;margin-right: 1%;"></div>
                    <div style="flex: 1;">More</div>
                </div>
                <div class="detailsBox">
                    <img class="detailsImg" src="../assets/images/details/jiemaogao.png" alt="">
                </div>
            </div>
        </div>
        <div v-else-if="productId === '2008'">
            <div class="top">
                <div class="left">
                    <img src="../assets/images/buyNew621/JMGDadi.jpg" alt="">
                </div>
                <div class="right">
                    <span>ΛKF 睫毛膏打底</span>
                    <ul>
                        <li>睫毛伴侣 定格卷翘</li>
                        <li>甄选植萃 温柔护睫</li>
                        <li>安心配方一抹净卸</li>
                    </ul>
                    <div class="buyBox">
                        <div class="guige">￥49/5g</div>
                        <!-- <div class="buy" @click="goToBuyPage">点击购买</div> -->
                        <div class="buy">点击购买</div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div style="display: flex;align-items: center;justify-content: center;padding: 0 10%;">
                    <div style="max-width: 100%;height: 2px;background-color: black;flex: 93%;margin-right: 1%;"></div>
                    <div style="flex: 1;">More</div>
                </div>
                <div class="detailsBox">
                    <img class="detailsImg" src="../assets/images/details/jiemaodadi.png" alt="">
                </div>
            </div>
        </div>
        <div v-else-if="productId === '2009'">
            <div class="top">
                <div class="left">
                    <img src="../assets/images/buyNew621/yanying.jpg" alt="">
                </div>
                <div class="right">
                    <span>ΛKF七色综合眼影盘</span>
                    <ul>
                        <li>星眸闪耀 灵动玩妆</li>
                        <li>柔润成分 妆感加持</li>
                    </ul>
                    <div class="buyBox">
                        <div class="guige">￥69.9/9g</div>
                        <!-- <div class="buy" @click="goToBuyPage">点击购买</div> -->
                        <div class="buy">点击购买</div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div style="display: flex;align-items: center;justify-content: center;padding: 0 10%;">
                    <div style="max-width: 100%;height: 2px;background-color: black;flex: 93%;margin-right: 1%;"></div>
                    <div style="flex: 1;">More</div>
                </div>
                <div class="detailsBox">
                    <img class="detailsImg" src="../assets/images/details/yanying.png" alt="">
                </div>
            </div>
        </div>
        <div v-else-if="productId === '2010'">
            <div class="top">
                <div class="left">
                    <img src="../assets/images/buyNew621/meibi.jpg" alt="">
                </div>
                <div class="right">
                    <span>ΛKF巧绘立体眉笔</span>
                    <ul>
                        <li>灵动三角 眉型自如</li>
                        <li>笔触顺滑 一笔显色</li>
                        <li>百搭四色 眉色随心</li>
                    </ul>
                    <div class="buyBox">
                        <div class="guige">￥29/220mg</div>
                        <!-- <div class="buy" @click="goToBuyPage">点击购买</div> -->
                        <div class="buy">点击购买</div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div style="display: flex;align-items: center;justify-content: center;padding: 0 10%;">
                    <div style="max-width: 100%;height: 2px;background-color: black;flex: 93%;margin-right: 1%;"></div>
                    <div style="flex: 1;">More</div>
                </div>
                <div class="detailsBox">
                    <img class="detailsImg" src="../assets/images/details/meibi.png" alt="">
                </div>
            </div>
        </div>
        <div v-else-if="productId === '2021'">
            <div class="top">
                <div class="left">
                    <img src="../assets/images/buyNew621/ximiannai.jpg" alt="">
                </div>
                <div class="right">
                    <span>ΛKF紫苏净颜洗面奶</span>
                    <ul>
                        <li>匀净提亮 改善暗沉肌</li>
                        <li>安全温和 不辣眼</li>
                    </ul>
                    <div class="buyBox">
                        <div class="guige">￥39/120g</div>
                        <!-- <div class="buy" @click="goToBuyPage">点击购买</div> -->
                        <div class="buy">点击购买</div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div style="display: flex;align-items: center;justify-content: center;padding: 0 10%;">
                    <div style="max-width: 100%;height: 2px;background-color: black;flex: 93%;margin-right: 1%;"></div>
                    <div style="flex: 1;">More</div>
                </div>
                <div class="detailsBox">
                    <img class="detailsImg" src="../assets/images/details/ximiannai.png" alt="">
                </div>
            </div>
        </div>
        <div v-else-if="productId === '2022'">
            <div class="none" style="margin-top: 3rem;">
                <h2>上新中</h2>
            <p>敬请期待...</p>
            </div>
        </div>
        <div v-else-if="productId === '2023'">
            <div class="top">
                <div class="left">
                    <img src="../assets/images/buyNew621/xiezhuangshui.jpg" alt="">
                </div>
                <div class="right">
                    <span>ΛKF紫苏净颜卸妆水</span>
                    <ul>
                        <li>多效合一 以水净妆</li>
                        <li>眼唇底妆 一瓶搞定</li>
                    </ul>
                    <div class="buyBox">
                        <div class="guige">￥59/500ml</div>
                        <!-- <div class="buy" @click="goToBuyPage">点击购买</div> -->
                        <div class="buy">点击购买</div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div style="display: flex;align-items: center;justify-content: center;padding: 0 10%;">
                    <div style="max-width: 100%;height: 2px;background-color: black;flex: 93%;margin-right: 1%;"></div>
                    <div style="flex: 1;">More</div>
                </div>
                <div class="detailsBox">
                    <img class="detailsImg" src="../assets/images/details/xiezuangshui.png" alt="">
                </div>
            </div>
        </div>
        <div v-else-if="productId === '2024'">
            <div class="none" style="margin-top: 3rem;">
                <h2>上新中</h2>
            <p>敬请期待...</p>
            </div>
        </div>
        <div v-else-if="productId === '2025'">
            <div class="top">
                <div class="left">
                    <img src="../assets/images/buyNew621/xiezhuangshijin.jpg" alt="">
                </div>
                <div class="right">
                    <span>ΛKF紫苏净颜卸妆湿巾</span>
                    <ul>
                        <li>全脸妆容 一张即净</li>
                        <li>舒适净肤 不干燥</li>
                    </ul>
                    <div class="buyBox">
                        <div class="guige">￥9.9/6ml</div>
                        <!-- <div class="buy" @click="goToBuyPage">点击购买</div> -->
                        <div class="buy">点击购买</div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div style="display: flex;align-items: center;justify-content: center;padding: 0 10%;">
                    <div style="max-width: 100%;height: 2px;background-color: black;flex: 93%;margin-right: 1%;"></div>
                    <div style="flex: 1;">More</div>
                </div>
                <div class="detailsBox">
                    <img class="detailsImg" src="../assets/images/details/xiezuangshijin.png" alt="">
                </div>
            </div>
        </div>
        <div v-else-if="productId === '2026'">
            <div class="top">
                <div class="left">
                    <img src="../assets/images/buyNew621/yanxianyebi.jpg" alt="">
                </div>
                <div class="right">
                    <span>ΛKF防水持久眼线液笔</span>
                    <ul>
                        <li>一笔成型 大放异彩</li>
                        <li>精细易绘 浓郁深邃</li>
                        <li>防水持妆 温和易卸</li>
                    </ul>
                    <div class="buyBox">
                        <div class="guige">￥49/600mg</div>
                        <!-- <div class="buy" @click="goToBuyPage">点击购买</div> -->
                        <div class="buy">点击购买</div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div style="display: flex;align-items: center;justify-content: center;padding: 0 10%;">
                    <div style="max-width: 100%;height: 2px;background-color: black;flex: 93%;margin-right: 1%;"></div>
                    <div style="flex: 1;">More</div>
                </div>
                <div class="detailsBox">
                    <img class="detailsImg" src="../assets/images/details/yanxianyebi.png" alt="">
                </div>
            </div>
        </div>
        <div v-else-if="productId === '1003'">
            <div class="top">
                <div class="left">
                    <img src="../assets/images/buyNew621/yanxianjiaobi.jpg" alt="">
                </div>
                <div class="right">
                    <span>ΛKF 眼线胶笔</span>
                    <ul>
                        <li>精致眼妆 一笔定睛</li>
                        <li>一笔勾勒 自然持妆</li>
                        <li>匠心工艺 质感上乘</li>
                    </ul>
                    <div class="buyBox">
                        <div class="guige">￥49/0.1g</div>
                        <!-- <div class="buy" @click="goToBuyPage">点击购买</div> -->
                        <div class="buy">点击购买</div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div style="display: flex;align-items: center;justify-content: center;padding: 0 10%;">
                    <div style="max-width: 100%;height: 2px;background-color: black;flex: 93%;margin-right: 1%;"></div>
                    <div style="flex: 1;">More</div>
                </div>
                <div class="detailsBox">
                    <img class="detailsImg" src="../assets/images/details/yanxianjiaobi.png" alt="">
                </div>
            </div>
        </div>
        <div v-else-if="productId === '3003'">
            <div class="top">
                <div class="left">
                    <img src="../assets/images/buyNew621/fendiye.jpg" alt="">
                </div>
                <div class="right">
                    <span>ΛKF 粉底液</span>
                    <ul>
                        <li>轻透美肌 恒久明亮</li>
                        <li>两大质地 随肌挑选</li>
                        <li>平衡水油 底妆服帖</li>
                        <li>植萃精华 水润不拔干</li>
                    </ul>
                    <div class="buyBox">
                        <div class="guige">￥89/35g</div>
                        <!-- <div class="buy" @click="goToBuyPage">点击购买</div> -->
                        <div class="buy">点击购买</div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div style="display: flex;align-items: center;justify-content: center;padding: 0 10%;">
                    <div style="max-width: 100%;height: 2px;background-color: black;flex: 93%;margin-right: 1%;"></div>
                    <div style="flex: 1;">More</div>
                </div>
                <div class="detailsBox">
                    <img class="detailsImg" src="../assets/images/details/fendiye.png" alt="">
                </div>
            </div>
        </div>
        <div v-else-if="productId === '5003'">
            <div class="top">
                <div class="left">
                    <img src="../assets/images/buyNew621/shuangyanpitie.jpg" alt="">
                </div>
                <div class="right">
                    <span>ΛKF 双眼皮贴</span>
                    <ul>
                        <li>一贴成型 放大双眼</li>
                        <li>肤色网纹 自然隐形</li>
                        <li>防水防汗 不易脱落</li>
                    </ul>
                    <div class="buyBox">
                        <div class="guige">￥39.9/120贴</div>
                        <!-- <div class="buy" @click="goToBuyPage">点击购买</div> -->
                        <div class="buy">点击购买</div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div style="display: flex;align-items: center;justify-content: center;padding: 0 10%;">
                    <div style="max-width: 100%;height: 2px;background-color: black;flex: 93%;margin-right: 1%;"></div>
                    <div style="flex: 1;">More</div>
                </div>
                <div class="detailsBox">
                    <img class="detailsImg" src="../assets/images/details/shuangyanpitie.png" alt="">
                </div>
            </div>
        </div>
        <div v-else>
            <div class="none" style="margin-top: 3rem;">
                <h2>上新中</h2>
            <p>敬请期待...</p>
            </div>

            
        </div>
    </div>
</template>

<script>
export default {
    name: 'BuyPage',
    data () {
        return {
            productId: this.$route.params.productId
        };
    },
    methods: {
        goToBuyPage () {
            // 根据产品ID生成对应的购买链接
            let buyLink;
            switch (this.productId) {
                case '1001':
                    buyLink = 'https://m.tb.cn/h.5PSQEvA?tk=QZOkW4WHwrg'; // 示例链接，替换为真实的购买链接
                    break;
                case '1002':
                    buyLink = 'https://m.tb.cn'; // 示例链接，替换为真实的购买链接
                    break;
                case '2001':
                    buyLink = 'https://detail.tmall.com/item.htm?spm=a1z10.3-b.w4011-22606257701.73.e3e151938QjaHD&id=661363560145&rn=9b879e3c8bb1488b8ffe203839b36888&abbucket=2'; // 示例链接，替换为真实的购买链接
                    break;
                case '2004':
                    buyLink = 'https://detail.tmall.com/item.htm?abbucket=19&id=696914505773&rn=4f7a679e68ff9d2bf314c703d13270cd&spm=a1z10.5-b.w4011-22606257698.46.791e5ce81P2JNT'; // 示例链接，替换为真实的购买链接
                    break;
                case '2006':
                    buyLink = 'https://detail.tmall.com/item.htm?id=631885545598&ali_refid=a3_430673_1006:1282830020:N:u2w/NLKHFL+cXAyXHm2wJw==:61c8c420cb57f380696fbe63376610e6&ali_trackid=1_61c8c420cb57f380696fbe63376610e6&spm=a2e'; // 示例链接，替换为真实的购买链接
                    break;
                case '2007':
                    buyLink = 'https://detail.tmall.com/item.htm?id=628454073225&ali_refid=a3_430673_1006:1282830020:N:K1z4h9QecfFRHKwEZg8EGh/JZIOQaxXy:643daa27ce2e0432183dbc94922bc84a&ali_trackid=162_643daa27ce2e0432183dbc94922bc8'; // 示例链接，替换为真实的购买链接
                    break;
                // 可以根据其他产品ID设置不同的购买链接
                default:
                    buyLink = '#'; // 默认链接
            }
            // 在新窗口中打开购买链接
            window.open(buyLink, '_blank');
        }
    }
};
</script>

<style scoped>
/* 移动端 */
@media only screen and (max-width: 996px) {
    .detailsImg {
        width: 80vw;
    }

    .right span {
        font-size: 1.2rem;
    }

    .right li {
        font-size: 0.8rem;
        font-weight: 300;
        color: #212121;
    }

    .buy {
        height: 2rem;
        width: 7rem;
        background-color: #333;
        color: #fff;
        list-style-type: none;
        line-height: 2rem;
    }

    .left img {
        width: 100%;
    }
    .detailsBox{
        margin-top: 1rem;
    }
}

/* 桌面端 */
@media only screen and (min-width: 996px) {
    .detailsImg {
        width: 50%;
    }

    .right span {
        font-size: 2.5rem;
    }

    .right li {
        font-size: 18px;
        font-weight: 300;
        color: #212121;
    }

    .buy {
        height: 40px;
        width: 150px;
        background-color: #333;
        color: #fff;
        list-style-type: none;
        line-height: 40px;
    }

    .left img {
        width: 50%;
    }
    .detailsBox{
        margin-top: 5rem;
    }
}

h1 {
    margin-bottom: 20px;
}

.buy-page {
    padding: 20px;
    /* width: 50%; */
}

.buyBox {
    display: flex;
    flex-direction: column;
    align-items: center;
}



.top {
    display: flex;
    text-align: center;
    align-items: center;
    margin-top: 90px;
}

.left {
    width: 50%;
}



.right ul {
    text-align: left;
}



.right .guige {
    text-align: left;
}

.bottom {
    text-align: center;
    /* margin-top: 60px; */
}</style>
